/**
 * Cuerpo del alta de pedido de venta.
 *
 * La forma de pago es la trampa: si el desplegable está en «La del cliente» **la clave no debe viajar**,
 * porque el servidor distingue «no me la mandes» (hereda la del cliente) de `null` («sin forma de
 * pago»). Mandarla como `null` dejaba el pedido sin forma de pago.
 */
export interface DatosPedidoVenta {
  customerId: string;
  shippingAddressId: string;
  paymentMethodId: string;
  orderedAt: string;
  promisedDate: string;
  notes: string;
  lineas: { modelId: string; quantity: number; unitPrice: number }[];
}

export function cuerpoPedidoVenta(datos: DatosPedidoVenta): Record<string, unknown> {
  return {
    customerId: datos.customerId,
    shippingAddressId: datos.shippingAddressId || null,
    // Sin elegir: fuera la clave. Nunca `null`.
    paymentMethodId: datos.paymentMethodId || undefined,
    orderedAt: datos.orderedAt,
    promisedDate: datos.promisedDate,
    notes: datos.notes || null,
    lines: datos.lineas.map((linea) => ({ ...linea, configuration: {} }))
  };
}
